import type { Job } from '../models';
import type { RestartJobRequest } from '../models/RestartJobRequest';
import { transcodeJobManagerAxios } from './interceptor';

// tslint:disable-next-line:variable-name
const TranscodeJobManagerService = {
  // log: new Log(),

  async fetchJobs(assetId: string): Promise<Array<Job>> {
    // sample:
    //
    // curl --request GET \
    //  --url https://transcodejobmngr-dev01-v1.mediapipe.com/Jobs/group/26e98018-660b-4ad7-b4cb-e580e784e7ba \
    //  --header 'Authorization: Bearer 50d23674cbdced0d9d7193d6c3d8f0410a9063206f91632faa2906300f94e9dc'
    const buildUrl = () => {
      const path = `Jobs/group/${assetId}`;
      return path;
    };

    const url = buildUrl();
    try {
      const res = await transcodeJobManagerAxios.get(url);
      return res.data;
    } catch (err) {
      console.error('err', err);
      // store.commit('alert/set', {
      //   message: clientUtils.errorResponseHandler(err, 'fetchJobs'),
      //   type: 'error',
      //   position: 'n',
      // });
      return err;
    }
  },

  // backend is returning a raw string in the response body that serves as a message...you can show it in the UI...
  async restartJob(jobId: string): Promise<string> {
    const payload: RestartJobRequest = {
      UpdatedCallback: null,
      ForceRestart: true,
      JobId: jobId,
    };

    const url = '/Jobs/restart';
    try {
      const res = await transcodeJobManagerAxios.post(url, payload);
      return res.data;
    } catch (err) {
      console.error('err', err);
      // store.commit('alert/set', {
      //   message: clientUtils.errorResponseHandler(error, 'restartJob'),
      //   type: 'error',
      //   position: 'n',
      // });
      return err;
    }
  },
};

export { TranscodeJobManagerService };
